import ko from "knockout";
import template from "./metabox.html";
import viewModel from "./metabox.viewmodel.js";

ko.components.register("metabox", { template, viewModel });
